import { render } from "./SiteFAQ.vue?vue&type=template&id=38cf5487&scoped=true"
import script from "./SiteFAQ.vue?vue&type=script&lang=js"
export * from "./SiteFAQ.vue?vue&type=script&lang=js"

import "./SiteFAQ.vue?vue&type=style&index=0&id=38cf5487&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cf5487"]])

export default __exports__